import { capitalizeAndCleanUnderscore } from "@utils";
import { FIELD_TYPES } from "@hyro-components/fields/utils";
import { INTEGRATIONS, LIST_TYPES, TABS } from "../consts";
import { hasExpressionFieldsAtDepth } from "./CollectionPage.utils";

// Which tab of the collection page a spec field is edited on. Shared by the page and the
// review-changes dialog so the dialog always points at the tab the user would open.
export const FIELD_TAB_BUCKETS = {
  GENERAL: "general",
  UTTERANCES: "utterances",
  LISTS: "lists",
  EXPRESSIONS: "expressions",
  COLLECTIONS: "collections"
};

export const getSpecFieldBucket = (field, collectionName) => {
  if (field?.type === FIELD_TYPES.ACTION) return FIELD_TAB_BUCKETS.UTTERANCES;
  if (field?.type === FIELD_TYPES.LIST && field?.element_spec?.type === LIST_TYPES.TABLE) return FIELD_TAB_BUCKETS.LISTS;
  if (collectionName === INTEGRATIONS && field?.type === FIELD_TYPES.OBJECT && hasExpressionFieldsAtDepth(field)) {
    return FIELD_TAB_BUCKETS.EXPRESSIONS;
  }
  if (field?.type === FIELD_TYPES.OBJECT) return FIELD_TAB_BUCKETS.COLLECTIONS;
  return FIELD_TAB_BUCKETS.GENERAL;
};

// The tab's label and its `?tab=` value, as CollectionPageTabs builds them.
export const getSpecFieldTab = (field, collectionName) => {
  switch (getSpecFieldBucket(field, collectionName)) {
    case FIELD_TAB_BUCKETS.UTTERANCES:
      return { label: TABS.names.utterances, value: TABS.names.utterances };
    case FIELD_TAB_BUCKETS.LISTS:
    case FIELD_TAB_BUCKETS.COLLECTIONS:
      return { label: capitalizeAndCleanUnderscore(field.display_key), value: field.display_key };
    case FIELD_TAB_BUCKETS.EXPRESSIONS:
      return { label: field.display_key, value: field.key };
    default:
      return { label: TABS.names.general, value: TABS.names.general };
  }
};
